import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

interface BackToDashboardButtonProps {
  className?: string;
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "default" | "lg";
}

/**
 * Componente de botón para volver al dashboard
 *
 * @description Se muestra para usuarios autenticados con rol de Apoderado o Estudiante
 * Permite navegar de vuelta al dashboard desde la tienda online
 */
export const BackToDashboardButton: React.FC<BackToDashboardButtonProps> = ({
  className = "",
  variant = "outline",
  size = "default",
}) => {
  const navigate = useNavigate();
  const { user, isAuthenticated, hasRole } = useAuth();

  // Solo mostrar para apoderados o estudiantes autenticados
  if (!isAuthenticated || !user || (!hasRole("Apoderado") && !hasRole("Estudiante"))) {
    return null;
  }

  const handleBackToDashboard = () => {
    if (hasRole("Estudiante")) {
      navigate("/student/dashboard");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleBackToDashboard}
      className={`gap-2 hover:scale-105 transition-all duration-200 ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      <Home className="h-4 w-4" />
      Volver al Dashboard
    </Button>
  );
};

export default BackToDashboardButton;
